export default {
  unavailable: {
    title: 'Kundenrechnungen sind nicht verfügbar',
    description:
      'Gäste können bei deinen Restaurants keine Rechnung anfordern, hier gibt es also nichts einzustellen. Bestellbelege und die Rechnungen deines Anbieters an dich sind davon nicht betroffen.',
  },
};
